import API_CONFIG from '../config/api';

export const performLogout = async () => {
  try {
    await API_CONFIG.client.post(API_CONFIG.ENDPOINTS.AUTH.LOGOUT);
  } catch (error) {
    console.error('Error logging out:', error);
  } finally {
    const authKeys = [
      'token',
      'userName',
      'userPicture',
      'userEmail',
      'googleId',
      'user_id',
    ];

    authKeys.forEach(key => localStorage.removeItem(key));

    window.location.href = '/login';
  }
};

export const clearAuthData = () => {
  const authKeys = [
    'token',
    'userName',
    'userPicture',
    'userEmail',
    'googleId',
    'user_id',
  ];

  authKeys.forEach(key => localStorage.removeItem(key));
};
